<template>
    <layout class="text-white">
        <!-- <section-hero :section-hero="sectionHero" /> -->
        <section-photo-gallery
            v-if="showPhotoGallery"
            id="photo-gallery"
            :section-gallery="sectionPhotoGallery" />
        <section-how-it-works :section-how-it-works="sectionHowItWorks" />
        <section-faq-static
            :section-faq="sectionFaq"
            :faq-items="faqItems"
            :faq-c-t-a="faqCTA" />
        <section-join-us />
    </layout>
</template>

<script>
import Layout from '@web/components/PageLayout';
// import SectionHero from '@web/pages/sections/PostProductionPage/SectionHero';
import SectionPhotoGallery from '@web/pages/sections/PostProductionPage/SectionGallery';
import SectionHowItWorks from '@web/pages/sections/shared/SectionHowItWorks';
import SectionFaqStatic from '@web/pages/sections/shared/SectionFaqStatic';
import SectionJoinUs from '@web/pages/sections/shared/SectionJoinUs';
import isEmpty from 'lodash/isEmpty';

export default {
  components: {
    Layout,
    // SectionHero,
    SectionPhotoGallery,
    SectionHowItWorks,
    SectionFaqStatic,
    SectionJoinUs,
  },
  props: {
    sectionHero: {
      type: Object,
      required: true,
    },
    sectionPhotoGallery: {
      type: Object,
      required: true,
    },
    sectionHowItWorks: {
      type: Object,
      required: true,
    },
    sectionFaq: {
      type: Object,
      required: true,
    },
    faqCTA: {
      type: Object,
      required: true,
    },
    faqItems: {
      type: Array,
      required: true,
    },
  },
  computed: {
    showPhotoGallery() {
      return !isEmpty(this.sectionPhotoGallery.productGallery);
    },
  },
};

</script>

<style scoped>
#photo-gallery {
    margin-top: 152px;
    scroll-margin-top: 152px;
}
</style>
